<template>
  <div v-if="shouldShowItem">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
          (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
          !item.alwaysShow
      "
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
        @click="handleMenuItemClick(onlyOneChild)"
      >
        <item
          :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          :title="onlyOneChild.meta.title"
        />
      </el-menu-item>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
          @click="handleMenuItemClick(item)"
        />
      </template>
      <sidebar-item
        v-for="child in filteredChildren"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import { org_access_money } from "@/api/user";
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    /**
     * 路由对象
     * 用于渲染侧边栏菜单项的数据
     */
    item: {
      type: Object,
      required: true
    },
    /**
     * 是否为嵌套菜单
     * 用于标识当前菜单项是否为子菜单项
     */
    isNest: {
      type: Boolean,
      default: false
    },
    /**
     * 基础路径
     * 用于拼接完整路径的基路径
     */
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  computed: {
    /**
     * 判断当前菜单项是否应该显示
     * @returns {Boolean} 如果应该显示返回true，否则返回false
     */
    shouldShowItem() {
      // 隐藏标记为hidden的菜单项
      if (this.item.hidden) {
        return false;
      }

      // 默认显示所有菜单项
      return true;
    },

    /**
     * 不再过滤子菜单，显示所有子菜单
     * @returns {Array} 所有子菜单数组
     */
    filteredChildren() {
      // 如果没有子菜单，直接返回空数组
      if (!this.item.children) {
        return [];
      }

      // 返回所有子菜单，不进行过滤
      return this.item.children.filter(child => {
        // 隐藏标记为hidden的菜单项
        if (child.hidden) {
          return false;
        }

        return true;
      });
    }
  },
  methods: {
    /**
     * 处理菜单项点击事件
     * @param {Object} item - 当前点击的菜单项
     */
    async handleMenuItemClick(item) {
      try {
        // 检查用户是否有访问权限
        const res = await org_access_money();
        const isVip = res.data; // 假设返回结果中有isVip字段
        const hideFor = item.meta && item.meta.vipHideFor;

        // 如果设置为对非VIP隐藏且用户不是VIP，则提示没有访问权限
        if (hideFor === "no-vip" && !isVip) {
          this.$message.error("您使用的是免费版，请使用训练计划（免费版）");
          return; // 阻止后续代码执行
        }

        // 如果有访问权限，执行正常的跳转逻辑
        this.$router.push(this.resolvePath(item.path));
      } catch (error) {
        console.error("Error checking access:", error);
        this.$message.error("检查访问权限时发生错误");
      }
    },
    /**
     * 判断是否只有一个需要显示的子路由
     * @param {Array} children - 子路由数组
     * @param {Object} parent - 父级路由对象
     * @returns {Boolean} 当只有一个需要显示的子路由时返回true，否则返回false
     */
    hasOneShowingChild(children = [], parent) {
      // 使用过滤后的可见子菜单
      const showingChildren = this.filteredChildren.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // 临时设置（将在只有一个显示子节点时使用）
          this.onlyOneChild = item;
          return true;
        }
      });

      // 当只有一个子路由器时，默认显示该子路由器
      if (showingChildren.length === 1) {
        return true;
      }

      // 如果没有要显示的子路由器，则显示父路由器
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    /**
     * 解析路由路径
     * @param {String} routePath - 路由路径
     * @returns {String} 解析后的完整路径
     */
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};
</script>
